













import Vue, { PropType } from "vue";
import { formatAmount, parseAmount } from "@/util/money";

type Rule = (text: string) => true | string;

export default Vue.extend({
  inheritAttrs: false,

  props: {
    value: {
      type: [Number, String],
      default: null
    },

    rules: {
      type: Array as PropType<Rule[]>,
      default: () => []
    }
  },

  data() {
    return {
      text: formatAmount(this.value),
      focused: false
    };
  },

  computed: {
    allRules(): Rule[] {
      return [
        (text: string) => parseAmount(text).valid || this.$t("office.validation.amount").toString(),
        ...this.rules
      ];
    }
  },

  watch: {
    value(next: number | string | null) {
      if (!this.focused) this.text = formatAmount(next);
    }
  },

  methods: {
    onInput(text: string | null): void {
      this.text = text ?? "";

      const parsed = parseAmount(this.text);

      if (parsed.valid) this.$emit("input", parsed.value);
    },

    onBlur(): void {
      this.focused = false;

      const parsed = parseAmount(this.text);

      if (parsed.valid) this.text = formatAmount(parsed.value);
    }
  }
});
